var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"u-container text-center pb-10"},[_c('h1',[_vm._v("Welcome Back")]),_c('p',{staticClass:"mt-2"},[_vm._v(" One moment while we process your extension order. ")]),_c('AppLoader',{staticClass:"mt-6"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }